/**
 * 硅基DUIX SDK
 */
import DUIX from "duix-guiji";

export default defineNuxtPlugin({
  name: "duix-guiji-plugin",
  parallel: true,
  setup(nuxtApp) {
    nuxtApp.provide("DUIX", DUIX);
  },
});

declare module "nuxt/app" {
  interface NuxtApp {
    $DUIX: any;
  }
}

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    $DUIX: any;
  }
}
